import { render, staticRenderFns } from "./UploadPDF.vue?vue&type=template&id=276f0fea&scoped=true&"
import script from "./UploadPDF.vue?vue&type=script&lang=js&"
export * from "./UploadPDF.vue?vue&type=script&lang=js&"
import style0 from "./UploadPDF.vue?vue&type=style&index=0&id=276f0fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276f0fea",
  null
  
)

export default component.exports